import { defineComponent, ref, watch, nextTick, onMounted, onUnmounted } from "vue";
import { storeToRefs } from "pinia";
import MessageText from "../MessageTypes/MessageText.vue.mjs";
import { isMobile } from "../../../utils/environment.mjs";
import useMessageList from "./useMessageListHook.mjs";
import { getScrollInfo } from "../../../utils/domOperation.mjs";
import { throttle } from "../../../utils/utils.mjs";
import { useRoomStore } from "../../../stores/room.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "MessageListPC",
  setup(__props) {
    const messageListRef = ref();
    const roomStore = useRoomStore();
    const { getDisplayName } = storeToRefs(roomStore);
    const {
      messageList,
      setMessageListInfo,
      handleGetHistoryMessageList,
      isCompleted,
      getDisplaySenderName
    } = useMessageList();
    let isScrollAtBottom = true;
    const handleMessageListScroll = (e) => {
      const messageContainer = e.target;
      const bottom = messageContainer.scrollHeight - messageContainer.scrollTop - messageContainer.clientHeight;
      isScrollAtBottom = bottom <= 80;
      if (messageContainer.scrollTop < 40 && !isCompleted.value) {
        handleGetHistoryMessageList();
      }
    };
    const handleScroll = throttle(handleMessageListScroll, 1e3);
    async function scrollToLatestMessage() {
      const { scrollHeight } = await getScrollInfo("#messageScrollList");
      if (messageListRef.value) {
        messageListRef.value.scrollTop = scrollHeight;
      }
    }
    watch(messageList, async (newMessageList, oldMessageList) => {
      var _a;
      if (newMessageList.length === 0) return;
      const lastMessage = newMessageList.slice(-1);
      const oldLastMessage = oldMessageList.slice(-1);
      const isSendByMe = lastMessage[0].flow === "out";
      const isNewMessage = lastMessage[0].ID !== ((_a = oldLastMessage[0]) == null ? void 0 : _a.ID);
      await nextTick();
      if (isScrollAtBottom) {
        scrollToLatestMessage();
        return;
      }
      if (isSendByMe && isNewMessage) {
        scrollToLatestMessage();
      }
    });
    onMounted(() => {
      var _a;
      setMessageListInfo();
      (_a = messageListRef.value) == null ? void 0 : _a.addEventListener("scroll", handleScroll);
    });
    onUnmounted(() => {
      var _a;
      (_a = messageListRef.value) == null ? void 0 : _a.removeEventListener("scroll", handleScroll);
    });
    return { __sfc: true, messageListRef, roomStore, getDisplayName, messageList, setMessageListInfo, handleGetHistoryMessageList, isCompleted, getDisplaySenderName, isScrollAtBottom, handleMessageListScroll, handleScroll, scrollToLatestMessage, MessageText, isMobile };
  }
});
export {
  _sfc_main as default
};
